function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { StyleSheet } from 'react-native';
import { View, Text } from "../../../native";
import { useFormContext } from "../FormContext";

function UnsupportedField({
  schema,
  idSchema,
  reason,
  formContext
}) {
  const {
    mapping
  } = useFormContext(formContext);
  return /*#__PURE__*/React.createElement(View, _extends({}, mapping.fieldContainer, {
    style: [mapping.fieldContainer.style]
  }), /*#__PURE__*/React.createElement(Text, _extends({}, mapping.description, {
    style: [mapping.description.style]
  }), "Unsupported field schema", idSchema && idSchema.$id && /*#__PURE__*/React.createElement(Text, _extends({}, mapping.label, {
    style: [mapping.label.style]
  }), ' for', ' ', "field", ' ', /*#__PURE__*/React.createElement(Text, {
    category: "s1"
  }, idSchema.$id)), reason && /*#__PURE__*/React.createElement(Text, _extends({}, mapping.description, {
    style: [styles.reasonText, mapping.description.style]
  }), ":", ' ', reason), "."), schema && /*#__PURE__*/React.createElement(Text, _extends({}, mapping.text, {
    style: [mapping.text.style]
  }), JSON.stringify(schema, null, 2)));
}

const styles = StyleSheet.create({
  reasonText: {
    fontStyle: 'italic'
  }
});
export default UnsupportedField;